// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r_WgC6AhAzyXRNJG{max-width:365px}.gWFsEs5gt0AI97H5{max-width:300}.VIzNr11BPeAwo5IN{text-align:right}.VIzNr11BPeAwo5IN .n8KBs0Q5lMjnJf6r{display:inline-block}.A0DEEStBXnAwaOeW{display:flex;justify-content:flex-end;gap:8px}.rfjpAhAIe0gT8Sz6{gap:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `r_WgC6AhAzyXRNJG`,
	"settingDescription": `gWFsEs5gt0AI97H5`,
	"toggleContainer": `VIzNr11BPeAwo5IN`,
	"toggleWrapper": `n8KBs0Q5lMjnJf6r`,
	"controlsContainer": `A0DEEStBXnAwaOeW`,
	"summaryContentCheckboxes": `rfjpAhAIe0gT8Sz6`
};
export default ___CSS_LOADER_EXPORT___;
